(function() {
	"use strict"

	/**
	 *
	 *	Customer
	 *
	 *
	 */
	angular.module("ATMGApi")

	.factory("ApiCustomer", [
		"ApiQuery",
		"$q",
		function(ApiQuery, $q) {

			var defer = $q.defer();

			return {

				status: {
					checkingCustomerNumber: false,
				},

				add: function( data, endpoint ) {

					if ( _.isUndefined( endpoint ) ) {
						endpoint = "auth/register"
					}

					var fields = {
						customer_number: "",
						customer_name: "",
						first: "",
						last: "",
						phone: "",
						email: "",
						address_line1: "",
						address_line2: "",
						address_line3: "",
						address_line4: "",
						province: "",
						postal_code: "",
						city: "",
						state: "",
						country: "",
						password: "",
						affiliate_mod_id: "",
					}

					_.extend( fields, data );
					return ApiQuery( endpoint, fields, "POST")
				},


				/**
				*
				*	fetch User data
				*
				*/
				fetchUserData: function() {
					return ApiQuery('auth/user', '', 'GET')
				},


				/**
				*
				*	user Activation
				*
				*
				*/
				activate: function ( activationCode ) {
					return ApiQuery( "customer/register/activate/" + activationCode, "",  "GET")
				},

				/**
				*
				*	user Verification
				*
				*
				*/
				verify: function ( verfiicationCode ) {
					return ApiQuery( "customer/register/verify/" + verfiicationCode, "",  "GET")
				},

				/**
				 *
				 * 	getBillingAddress
				 *
				 */
				getBillingAddress: function() {
					return ApiQuery( "customer/", "", "GET" )
				},

				/**
				 *
				 * 	getAllAddresses
				 *
				 * @param params obj  i.e.  { where: [ [ 'account_number', '=', account_number ]. [...] ] }
				 */
				getAddresses: function(filters, site_use_id) {
					if (!site_use_id) {
						site_use_id = ''
					}
					let endpoint = 'customer/addresses/' + site_use_id;
					return ApiQuery(endpoint, filters, "GET")
				},

				/**
				*
				*		checkCustomerNumber
				*
				*/
				checkCustomerNumber: function( customerNumber ) {
					return new Promise((resolve, reject) => {
						this.status.checkingCustomerNumber = true
						ApiQuery("customer/check", {customer_number: customerNumber})
							.then(response => {
								this.status.checkingCustomerNumber = false
								resolve(true);
							})
							.catch(response => {
								this.status.checkingCustomerNumber = false
								reject(response.data.error)
							})
					})
				},

				/**
				 *
				 * 	getContacts
				 *
				 */
				getContacts: function(relatedAccountNumber, filters) {
					let role_id = ''
					// @NOTEW it's not entirely clear to me why we clear the filters in that case
					// it should be rather doing what's in the commented out line
					// leaving it here 
					if (filters && filters.where && typeof filters.where.cust_account_role_id !== undefined) {
						role_id = filters.where.cust_account_role_id
						filters = undefined
						// delete filters.where.cust_account_role_id
					}
					return ApiQuery(`customer/${relatedAccountNumber}/contacts/${role_id}`, filters, 'GET')
						.then(response => {
							if (!response.data.success) {
								return;
							}
							if (response.data.data.length) {
								_.each(response.data.data, function(d) {
									var first_name = d.person_first_name || "";
									var last_name = d.person_last_name || "";
									d.person_full_name = first_name + " " + last_name;
								})
							} else if (response.data.data) {
								response.data.data.person_full_name = response.data.data.person_first_name + ' ' + response.data.data.person_last_name
							}
							return response.data.data;
						})
				}
			}
		}
	])
})()


// WEBPACK FOOTER //
// ./src/app/modules/ATMGApi/factories/Customer.js